var render = function render(){var _vm=this,_c=_vm._self._c;return _c('checkbox',{staticClass:"justify-center",attrs:{"checked":_vm.isApproved,"disabled":!_vm.hasProfile},on:{"value":_vm.onChange}},[_c('div',{staticClass:"ml-2 text-xs"},[_vm._v("подтвержден")])])
}
var staticRenderFns = []

export { render, staticRenderFns }